module.exports = __webpack_public_path__ + "static/img/ISO14001_Renwu_mobile.d9d612b6.jpg";